var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.view == 'stock-minimo')?_c('div',[_c('list-articles')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }